import { render, staticRenderFns } from "./diqu.vue?vue&type=template&id=0ae1a07f&scoped=true"
import script from "./diqu.vue?vue&type=script&lang=js"
export * from "./diqu.vue?vue&type=script&lang=js"
import style0 from "./diqu.vue?vue&type=style&index=0&id=0ae1a07f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae1a07f",
  null
  
)

export default component.exports